import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGES } from "../../../services/Constants/Languages";
import en from "./locales/en";
import { timeFromNow } from "./locales/timeFromNow";

const resources = {
    en: {
        translation: en,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: DEFAULT_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGES,

    keySeparator: ".",

    interpolation: {
        escapeValue: false,
    },
});
i18n.services.formatter?.add("fromNow", (value, _lng, _options) => {
    const date = new Date(value);
    return timeFromNow(date);
});

export default i18n;
